<template>
  <header class="d-flex flex-row text-light p-0 justify-content-between align-items-center px-4">
    <img class="logo" src="@/assets/img/logo-h.svg" v-if="$route.name == 'maps'" />
    <h4 class="m-0" v-if="$route.name != 'maps'">{{title}}</h4>
    <MenuHeader></MenuHeader>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MenuHeader from '@/components/headers/MenuHeader.vue'
export default defineComponent({
  components: { MenuHeader },
  updated(){
    this.title = this.changeTitle()
  },
  data() {
    return {
      title: 'Reportes',
    }
  },
  methods: {
    changeTitle() {
      switch (this.$route.name) {
        case 'reports':
          return 'Reportes'
        case 'alerts':
          return 'Alertas'
        default:
          return 'Error'
      }
    }
  }
})
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'

header
    background: $primary
    height: 60px
    .logo
        height: 50px
</style>
